import styled, { css, keyframes } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { boxStyles } from '../Box/styles.js';
import { boxPropExclusions } from '../Box/props.js';

var viewBoxSize = 48;
var totalDeg = 3 * 360;
var loadingAnimation = /*#__PURE__*/keyframes(["0%{stroke-dashoffset:", ";transform:rotate(0deg);}50%{stroke-dashoffset:", ";transform:rotate(", "deg);}100%{stroke-dashoffset:", ";transform:rotate(", "deg);}"], viewBoxSize * 0.66, viewBoxSize * 2.97, totalDeg / 1.5, viewBoxSize * 0.66, totalDeg);
var loadingAnimationIE = /*#__PURE__*/keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(", "deg);}"], totalDeg);
var wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-9oa3rf-0"
})(["height:100%;width:100%;"]);
var loader = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__loader",
  componentId: "sc-9oa3rf-1"
})(["display:inline-block;height:", ";width:", ";svg{height:100%;width:100%;}circle{stroke-width:6;stroke-dasharray:", ";", "}", " ", ""], function (props) {
  return px2rem(props.$size);
}, function (props) {
  return px2rem(props.$size);
}, viewBoxSize * 3.14, function (props) {
  return !props.$isIE && css(["animation:", " 2.7s linear infinite;transform-origin:", "px ", "px 0;"], loadingAnimation, viewBoxSize * 0.5, viewBoxSize * 0.5);
}, function (props) {
  return props.$isIE && css(["", "{animation:", " 2.7s linear infinite;}circle{stroke-dashoffset:", ";}"], wrapper, loadingAnimationIE, viewBoxSize * 0.785);
}, boxStyles);

export { loader, wrapper };
